var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5H18.5C18.5 10.7173 10.2173 19 0 19V0.5Z",
    fill: "#1D68F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 37.5H18.5C18.5 27.2827 10.2173 19 0 19V37.5Z",
    fill: "#1D68F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37 0.5H18.5C18.5 10.7173 26.7827 19 37 19V0.5Z",
    fill: "#1D68F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37 37.5H18.5C18.5 27.2827 26.7827 19 37 19V37.5Z",
    fill: "#1D68F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHms);
export default __webpack_public_path__ + "static/media/hms.9a9938a2933603f4f195dab9f1c983f2.svg";
export { ForwardRef as ReactComponent };